/** Handle email pattern. */
export const EMAIL = {
  message: 'Enter your email address',
  value: /.@.*\../,
}
